import zamOne from '../../assets/images/icons/zam-one.png';
import zamTwo from '../../assets/images/icons/zam-two.png';
import zamThree from '../../assets/images/icons/zam-three.png';
import zamFour from '../../assets/images/icons/zam-four.png';
import { CardSettings } from '../../interfaces';
import step1 from '../../assets/images/icons/zam-upload-document.svg';
import step2 from '../../assets/images/icons/zam-add-sign.svg';
import step3 from '../../assets/images/icons/zam-confirm-sign.svg';
import step4 from '../../assets/images/icons/zam-download.svg';
import { routes } from '../../models';
import { Link } from 'react-router-dom';

export const ITEMS_CARD: CardSettings[] = [
  {
    icon: zamOne,
    altIcon: 'one',
    title: 'Upload Your Document',
    description:
      'Click the [Upload File] button or drag and drop a PDF file from your computer into the upload area.',
    img: step1,
  },
  {
    icon: zamTwo,
    altIcon: 'two',
    title: 'Add Your Signature',
    description:
      'Drag and drop the [Signature] field onto your document, place it in the correct position, and click [Sign] to proceed.',
    img: step2,
  },
  {
    icon: zamThree,
    altIcon: 'three',
    title: 'Confirm Your Signature',
    description:
      'Check your ZamGov app on your mobile phone. Enter the 6-digit OTP to confirm and authorize your signature.',
    img: step3,
  },
  {
    icon: zamFour,
    altIcon: 'three',
    title: 'Download or Preview',
    description:
      'Congratulations! You have successfully signed the document. You can now download it or preview it.',
    img: step4,
  },
];

export const TITLE = 'How to Digitally Sign a Document';
export const CONFIG_STYLES = 'col-12 col-md-6 col-lg-3';
export const DESCRIPTION_AUTHENTICATE = (
  <p>
    To continue, check the{' '}
    <Link
      className="text-warning text-decoration-none"
      to={routes.userGuidelines}
    >
      User Guidelines
    </Link>{' '}
    and authenticate via ZamPass.
  </p>
);
export const LABEL_BTN_SIGN = 'Sign In with ZamPass';
